// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2TpGD","consentsList":"PatientConsents_consentsList__2XGV3","consentsListEmpty":"PatientConsents_consentsListEmpty__3OpK-"};